import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {


  todos = [
    
    {date: '27.01.21', title: 'Kasa component' ,description: 'gün sonu ve devir için', priority: 5, status: 'pend' },
    {date: '18.02.21', title: 'Item edit component' ,description: 'yeni ürün açma ve eski ürün editleme', priority: 5, status: 'pend' },
    {date: '06.02.21', title: 'Logger service ekle', description: 'hata ve çeşitli eventleri loglamalı', priority: 2, status: 'pend' },
    {date: '04.02.21', title: 'alışverişi tamamla: Deal' ,description: 'fs Deals collectiona yazılacak', priority: 5, status: 'pend' },
    {date: '26.01.21', title: 'PI parçalarını kaldır' ,description: 'Cart class hem PI için hem POS için kullanılabilmeli: multiple instance çalışmalı', priority: 3, status: 'done' },
    {date: '26.01.21', title: 'POS eklentileri' ,description: 'site satışlarına uygun hale getir', priority: 4, status: 'pend' },
    {date: '27.01.21', title: 'Sheete kaydet seçeneği eklenecek' ,description: 'satış ve alış için', priority: 1, status: 'pend' },
    {date: '27.01.21', title: 'Yeni ürün liste component' ,description: 'yeni ürün ve edit için', priority: 5, status: 'pend' },
    {date: '27.01.21', title: 'CRUD ops' ,description: 'firestore satış ve alış kaydı ', priority: 5, status: 'pend' },
    {date: '27.01.21', title: 'firestore rules' ,description: 'yetki ayarları', priority: 4, status: 'pend' },
    {date: '30.01.21', title: 'search comp Add to bulunamadı' ,description: 'ürün bulunamazsa bulunamayanlar listesine ekleme butonu - bu liste kullanılarak yeni ürün açılabilecek', priority: 3, status: 'pend' },
    {date: '03.02.21', title: 'GoogleAuth cart bozuluyor' ,description: 'bozulmaması gerekiyor', priority: 1, status: 'pend' },
  ];

  versions = [
    {date: '26.01.21', v: '0.00.1', changed: 'şu bu değişti'},
    {date: '26.01.21', v: '0.00.1', changed: 'şu bu değişti'},
    {date: '26.01.21', v: '0.00.1', changed: 'şu bu değişti'},
    {date: '26.01.21', v: '0.00.1', changed: 'şu bu değişti'},
    {date: '26.01.21', v: '0.00.1', changed: 'şu bu değişti'},
  ];

  workDone = [
    {date: '06.02.21', work: 'fixed formState reload on turning back to POS page (it was not reloading)'}
  ]

  constructor() { }

  ngOnInit(): void {
this.sortTodos();
  }

  sortTodos() {
    this.todos.sort((a, b) => b.priority -a.priority);
  }

}
